import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import conf from 'conf/conf';

const STEPS = [1, 2, 3] as const;

const TariffInfo = () => {
    const { t } = useTranslation('Tariff');
    const telegramHandle = String(conf.tariffTelegram || '@e_landing');
    const telegramUrl = `https://t.me/${telegramHandle.replace(/^@/, '')}`;

    const renderStepText = (step: typeof STEPS[number]) => {
        if (step === 3) {
            return (
                <p className="text-muted f-12 mb-0">
                    {t('purchaseInfo.step3Text')}{' '}
                    <a
                        href={telegramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fw-medium"
                    >
                        {telegramHandle}
                    </a>
                    {t('purchaseInfo.step3TextAfter')}
                </p>
            );
        }

        return (
            <p className="text-muted f-12 mb-0">
                {t(`purchaseInfo.step${step}Text`)}
            </p>
        );
    };

    return (
        <Card className="mb-4">
            <Card.Body>
                <h5 className="mb-1 fw-bold">{t('purchaseInfo.title')}</h5>
                <p className="text-muted f-12 mb-4">{t('purchaseInfo.intro')}</p>

                <Row className="g-3">
                    {STEPS.map((step) => (
                        <Col key={step} md={4}>
                            <div className="d-flex align-items-start gap-2">
                                <div className="avtar avtar-s bg-light-primary flex-shrink-0">
                                    <span className="fw-bold text-primary">{step}</span>
                                </div>
                                <div>
                                    <h6 className="mb-1 fs-12 fw-bold">
                                        {t(`purchaseInfo.step${step}Title`)}
                                    </h6>
                                    {renderStepText(step)}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default TariffInfo;
